var $ = require('jquery');
var _ = require('underscore');
var Configuration = EY.Consultation.Lookups.Configuration;
var Entities = require('Entities');
var Solr = require('Solr');
var StatusType = EY.Consultation.Lookups.StatusType;

var checksum = function (options) {
    var record = options.record;
    var configuration = record.get('configuration');

    if (record.get('statusTypeId') === StatusType.ReviewApproval && record.get('statusTypeId') === options.history.statusTypeId && record.get('validChecksum')) {
        var source = _.pluck(_.sortBy(options.history.attachments, 'filename'), 'date').join('|');
        var target = _.pluck(_.sortBy(options.attachments.toJSON(), 'filename'), 'date').join('|');

        record.set('validChecksum', configuration.DisplayDescription ? options.history.description === options.record.get('description') && source === target : source === target);
    }
};

module.exports.start = function (options) {
    var deferred = $.Deferred();
    var edited = new Entities.Attachments(options.attachments.filter({ edited: true }) || []);
    var unedited = new Entities.Attachments(options.attachments.filter(function (model) { return !model.has('edited'); }) || []);
    var promise = deferred.promise();

    if (edited.length > 0) {
        var files = _.extend(new Entities.Attachments(), { url: options.record.urlRoot.replace('Record', 'Attachment') });
        var zone = edited.first().get('zone');

        files.fetch({
            filter: {
                _id: {
                    $in: _.map(edited.pluck('id'), function (id) { return { $oid: '' + id + '' }; })
                },
                "metadata.zone": zone
            }
        }).done(function () {
            edited.each(function (attachment) {
                var file = files.get(attachment.id);

                attachment.set('date', _.last(new Date(file.get('metadata').uploadDate.$date).toGMTString().split(',')));
                attachment.set('filelength', file.get('length'));
                attachment.set('hasComments', file.get('metadata') ? file.get('metadata').hasComments : false);
                attachment.set('hasTrackChanges', file.get('metadata') ? file.get('metadata').hasTrackChanges : false);
                attachment.set('size', Math.round(file.get('length') / 1024) + 'KB');
                attachment.unset('edited', { silent: true }); // Do not trigger change:edited event

                var history = _.chain(options.history.attachments).findWhere({ id: attachment.id }).value();
                var sized = Configuration.DocumentSize >= file.get('length');
 
                if (sized && (!history || attachment.get('date') != history.date)) {
                    Solr.update(attachment);
                }
            });
            checksum(options);
            if (options.record.id) {
                var record = $.extend(true, {}, options.history);
                record.attachments = (JSON.parse(JSON.stringify(edited))).concat(JSON.parse(JSON.stringify(unedited)));
                record.validChecksum = options.record.get('validChecksum');
                new Entities.Record(record).save({ validate: false });
            } //update edited attachments collection 

            deferred.resolve();
        });
    } else {
        checksum(options);
        deferred.resolve();
    }
    return promise;
};

module.exports.validateAttachments = function (options) {
    var deferred = $.Deferred();
    var promise = deferred.promise();
    var recordAttachments = options.attachments;
    var fsFiles = _.extend(new Entities.Attachments(), { url: options.record.urlRoot.replace('Record', 'Attachment') });
    var zone = recordAttachments.length > 0 && recordAttachments.first().get('zone');
    var corruptedAttachments = [];
    fsFiles.fetch({
        filter: {
            _id: {
                $in: _.map(recordAttachments.pluck('id'), function (id) { return { $oid: '' + id + '' }; })
            },
            "metadata.zone": zone
        }
    }).done(function () {
        recordAttachments.each(function (attachment) {
            var file = fsFiles.get(attachment.id);
            if (file) {
                return false;
            } else {
                corruptedAttachments.push(attachment.get('filename'));
            }    
        });
        deferred.resolve(corruptedAttachments);
    }).fail(function () {
        deferred.resolve(corruptedAttachments);
    });
    return promise;
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordDocumentationSync.js